import React from 'react';
import { Flex, Link } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

import Text from './Text';

const DetailRow = ({
  label,
  value,
  bold,
  externalLink,
  labelStyle,
  labelProps,
  valueStyle,
  valueProps,
  ...props
}) => {
  return (
    <Flex flexDirection="row" justifyContent="space-between" {...props}>
      <Text
        textStyle="bodyGrey2"
        color="richBlack"
        style={{ ...(bold && { fontWeight: 'bold' }), ...(labelStyle && labelStyle) }}
        flexShrink={0}
        width="60%"
        {...labelProps}
      >
        {label}
        {
          externalLink && (
            <Link href={externalLink} isExternal>
              <ExternalLinkIcon
                style={{ marginTop: '-0.3em' }}
                mx="3px"
              />
            </Link>
          )
        }
      </Text>
      <Text
        textStyle="bodyGrey2"
        textAlign="right"
        flexShrink={0}
        style={valueStyle}
        {...valueProps}
      >
        {value}
      </Text>
    </Flex>
  );
};

export default DetailRow;
